(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.VisibilityDependence = Lfl.VisibilityDependence || {};

    (function (VisibilityDependence, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.VisibilityDependence, 'VdoiControllingInputResolver')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * Helps other VDOI components resolve the input element's attributes (both initially and during operations).
         *
         * @param {string} [parameters.path] Path to the element of the controlling input. Either path or name must be
         * provided.
         * @param {string} [parameters.name] Name of the controlling input. Either path or name must be provided.
         * @param {string | Array | bool} [parameters.desiredValue] The value or an array of values of which at least
         * one has to be selected for the controlled element to be visible. Defaults to 'true' for checkboxes, must be
         * provided for other input types.
         * @param {string} [parameters.type] The controlling input's type, can be 'radio', 'select' or 'checkbox'. If
         * not provided, then the type will be resolved automatically based on the input. Later - Vdoi::RemoveOldHiw -
         * this parameter should be possible to later be removed.
         * @param {string|boolean} parameters.desiredValue The value to be set for the controlled input to be visible.
         *
         * @memberOf Lfl.VisibilityDependence
         * @lends Lfl.VisibilityDependence.VdoiControllingInputResolver
         * @constructor
         */
        Lfl.VisibilityDependence.VdoiControllingInputResolver = function (parameters) {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */
            var vcir = this;
            /**
             * One or several controlling inputs (several for radio buttons).
             * @type {jQuery}
             */
            var $controllingInput;
            var type;
            var desiredValue;
            var currentValuePath;

            function init() {
                initInputAttributes();
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */


            /*
            |----------------------------------------------------------------------------------------
            | Getters
            |---------*/

            /**
             * @returns {jQuery}
             */
            this.getControllingInput = function () {
                return $controllingInput;
            };

            this.getType = function () {
                return type;
            };

            /**
             * The value which should be selected for the element to be visible.
             * @returns {string | Array | bool}
             */
            this.getDesiredValue = function () {
                return desiredValue;
            };

            /**
             * Is the desired value (or one of the desired values) currently selected?
             *
             * @returns {boolean}
             */
            this.isValueSelected = function () {
                var currentValue = determineCurrentValue();
                switch (type) {
                    case 'checkbox':
                        return desiredValue === currentValue;
                    case 'radio':
                    case 'select':
                        // Multi-value
                        return false === _.isEmpty(_.intersection(desiredValue, currentValue));
                    default:
                        throw new Error('Unknown input type ' + type);
                }
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /*
            |----------------------------------------------------------------------------------------
            | Value reading
            |---------------*/

            function determineCurrentValue() {
                var currentValue;
                var $currentValueElement = $(currentValuePath);
                switch (type) {
                    case 'checkbox':
                        currentValue = $currentValueElement.is(':checked');
                        break;
                    case 'radio':
                    case 'select':
                        currentValue = $currentValueElement.val();
                        currentValue = processValue(currentValue);
                        break;
                    default:
                        throw new Error('Unknown input type ' + type);
                }

                return currentValue;
            }

            function processValue(value) {
                if (type === 'checkbox') {
                    if (_.isArray(value)) {
                        if (value.length !== 1) {
                            throw new Error("Checkbox should have exactly one desired value - true, or false. No need " +
                                "to pass it as array, by the way.");
                        }
                        value = value.shift();
                    }
                } else {
                    // Prepare value - unify the value which may come from various input types (multi-select vs. select, ...).
                    if (typeof value === 'string') {
                        value = [value];
                    }

                    value = Lfl.String.convertValuesToStrings(value);
                }

                return value;
            }

            /*
            |----------------------------------------------------------------------------------------
            | Initialization
            |----------------
            | Private functions used when initializing */
            function initInputAttributes() {
                // Later: We could also allow: if(parameters.hasOwnProperty("$element");
                var path = determineInputPath();

                $controllingInput = $(path);

                type = determineInputType();

                desiredValue = parameters.hasOwnProperty("desiredValue") && typeof parameters.desiredValue !== 'undefined'?
                    processValue(parameters.desiredValue) : determineDefaultValue();

                if (type === 'radio' || type === 'checkbox') {
                    currentValuePath = path + ':checked';
                } else {
                    currentValuePath = path;
                }
            }

            function determineInputPath() {
                var path;

                if (parameters.hasOwnProperty("path") && typeof parameters.path !== 'undefined') {
                    path = parameters.path;
                    if (parameters.hasOwnProperty("name") && typeof parameters.name !== 'undefined') {
                        console.warn("Both path and name parameters of controllingInput were provided => " +
                            "ignoring name.");
                    }
                } else {
                    if (parameters.hasOwnProperty("name") && typeof parameters.name !== 'undefined') {
                        path = determineInputPathByName(parameters.name);
                    }
                }

                if (typeof path === 'undefined') {
                    throw new Error("Unable to determine element path.");
                }

                return path;
            }

            function determineInputPathByName(name) {
                return '[name="' + name + '"]';
            }

            function determineDefaultValue() {
                if (type === 'checkbox') {
                    return true;
                }

                throw new Error("Default value or values have to be defined for controlling input of type " + type + ".");
            }

            function determineInputType() {
                var inputHtmlTag = $controllingInput.prop("tagName").toLowerCase();

                if (inputHtmlTag === 'input') {
                    var inputTypeAttribute = $controllingInput.attr('type');
                    switch (inputTypeAttribute) {
                        // Whitelist of known types
                        case 'radio':
                        case 'checkbox':
                            return inputTypeAttribute;
                        default:
                            throw new Error('Unable to handle input type ' + inputTypeAttribute);
                    }
                } else if (inputHtmlTag === 'select') {
                    return 'select';
                }

                throw new Error('Unable to handle input element of tag ' + inputHtmlTag);
            }

            /*
             |-------------------------------------------------------------------------------------------------------
             | First initialization
             |-------------------------------------------------------------------------------------------------------
             */
            init();
        };
    }(Lfl.VisibilityDependence, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
